var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrequency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#96CEFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#B5DEFF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 11.3333L19.8334 13.3333M19.8334 13.3333L17.8334 15.3333M19.8334 13.3333H15.0334C13.9133 13.3333 13.3532 13.3333 12.9254 13.5512C12.5491 13.743 12.2431 14.0489 12.0514 14.4253C11.8334 14.8531 11.8334 15.4131 11.8334 16.5333V20.3333C11.8334 20.6429 11.8334 20.7977 11.8505 20.9276C11.9686 21.8251 12.6749 22.5313 13.5723 22.6495C13.7023 22.6666 13.8571 22.6666 14.1667 22.6666M17.1667 22.6666H21.9667C23.0868 22.6666 23.6469 22.6666 24.0747 22.4486C24.451 22.2569 24.757 21.9509 24.9487 21.5746C25.1667 21.1467 25.1667 20.5867 25.1667 19.4666V15.6666C25.1667 15.357 25.1667 15.2022 25.1496 15.0722C25.0314 14.1747 24.3252 13.4685 23.4278 13.3504C23.2978 13.3333 23.143 13.3333 22.8334 13.3333M17.1667 22.6666L19.1667 24.6666M17.1667 22.6666L19.1667 20.6666",
    stroke: "#0265DC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequency);
export default __webpack_public_path__ + "static/media/frequency.4fc996834e77db5cadacc200278b388d.svg";
export { ForwardRef as ReactComponent };